// @todo why is helper circ dep here?
import Helper from 'utils/Helper.class'
import strings from 'lib/constants/strings'
import { vsprintf } from 'sprintf-js'
import { RouteNamesExternal } from 'constants/routeNamesExternal'
import qs from 'qs'
console.log(Helper)
/**
 *
 * @param index
 * @param filter
 */
// @todo causes circ dependency when imported from helper class, why?
const createSearchLink = (index: string, filter: string): string => {
  const createURL = (state: Record<string, unknown>) =>
    qs.stringify(state, { addQueryPrefix: true, format: 'RFC1738' })

  const searchState = {
    hierarchicalMenu: {
      'contentTypes.lvl0': filter,
    },
  }
  return `${process.env.PUBLIC_URL}/search/${index}${createURL(
    searchState,
  )}&toggle%5BmemberBenefit%5D=true&page=1`
}

export const tabIndexes = {
  PUBLICATIONS: 0,
  VIDEOS: 1,
  PERFORMANCE_RESOURCES: 2,
  ARTICLES: 3,
  WEBINARS: 4,
  COURSES: 5,
}

export const tabs = {
  PUBLICATIONS: 'publications',
  VIDEOS: 'videos',
  PERFORMANCE_RESOURCES: 'performanceResources',
  ARTICLES: 'articles',
  WEBINARS: 'webinars',
  COURSES: 'courses',
}

export const requests = {
  CASE_STUDIES: 'caseStudies',
  TD_MAGAZINES: 'tdMagazines',
  WHITE_PAPERS: 'whitePapers',
  VIDEOS: 'videos',
  WORK_GUIDES: 'workGuides',
  TEMPLATE_TOOLS: 'templateTools',
  NEWS_LETTER: 'newsletter',
  TD_MAGAZINE_ARTICLES: 'tdMagazineArticles',
  WEBINARS: 'webinars',
}

export const tabsConfig = {
  [tabs.PUBLICATIONS]: {
    tabName: 'Publications',
    link: createSearchLink('publications_orderby_date_desc', 'Publication'),
    requests: {
      [requests.CASE_STUDIES]: {
        getInput: (isMobile: boolean) => ({
          index: 'publications_orderby_date_desc',
          pageSize: isMobile ? 1 : 2,
          filters:
            '(contentTypes.lvl2:"Publication > Research > Case Study") AND (memberBenefit:true)',
        }),
        title: 'Case Studies',
        description:
          'A curated collection of proven talent development case study solutions from top-performing organizations around the world.',
        link: createSearchLink(
          'publications_orderby_date_desc',
          'Publication > Research > Case Study',
        ),
      },
      [requests.TD_MAGAZINES]: {
        getInput: (isMobile: boolean) => ({
          index: 'publications_orderby_date_desc',
          pageSize: isMobile ? 1 : 2,
          filters:
            '(contentTypes.lvl2:"Publication > Magazine > TD Magazine") AND (memberBenefit:true)',
        }),
        title: 'TD Magazines',
        description:
          "Full digital issues of our monthly award-winning magazine delivering the best of the industry's top trends and topics.",
        link: createSearchLink(
          'publications_orderby_date_desc',
          'Publication > Magazine > TD Magazine',
        ),
      },
      [requests.WHITE_PAPERS]: {
        getInput: (isMobile: boolean) => ({
          index: 'publications_orderby_date_desc',
          pageSize: isMobile ? 1 : 2,
          filters:
            '(contentTypes.lvl2:"Publication > Research > Whitepaper") AND (memberBenefit:true)',
        }),
        title: 'White Papers',
        description:
          'These data-driven reports highlight insights and key findings from our full research reports at a glance.',
        link: createSearchLink(
          'publications_orderby_date_desc',
          'Publication > Research > Whitepaper',
        ),
      },
    },
  },
  [tabs.VIDEOS]: {
    tabName: 'Videos',
    link: createSearchLink('videos_orderby_date_desc', ''),
    requests: {
      [requests.VIDEOS]: {
        getInput: () => ({
          index: 'videos_orderby_date_desc',
          pageSize: 6,
          filters: 'memberBenefit:true',
        }),
        title: 'Videos',
        description: strings.BENEFITS.MEMBER_BENEFITS.VIDEO.DESCRIPTION,
        link: createSearchLink('videos_orderby_date_desc', ''),
      },
    },
  },
  [tabs.PERFORMANCE_RESOURCES]: {
    tabName: 'Performance Resources',
    link: createSearchLink(
      'performance_resources_orderby_date_desc',
      'Performance Resource',
    ),
    requests: {
      [requests.WORK_GUIDES]: {
        getInput: (isMobile: boolean) => ({
          index: 'performance_resources_orderby_date_desc',
          pageSize: isMobile ? 1 : 2,
          filters:
            '(contentTypes.lvl1: "Performance Resource > TD at Work Guide") AND (memberBenefit:true)',
        }),
        title: 'TD at Work Guides',
        description: strings.BENEFITS.MEMBER_BENEFITS.TD_AT_WORK.DESCRIPTION,
        link: createSearchLink(
          'performance_resources_orderby_date_desc',
          'Performance Resource > TD at Work Guide',
        ),
      },
      [requests.TEMPLATE_TOOLS]: {
        getInput: (isMobile: boolean) => ({
          index: 'performance_resources_orderby_date_desc',
          pageSize: isMobile ? 1 : 2,
          filters:
            '(contentTypes.lvl1: "Performance Resource > Templates and Tools") AND (memberBenefit:true)',
        }),
        title: 'Templates and Tools',
        description: vsprintf(
          strings.BENEFITS.MEMBER_BENEFITS.TEMPLATES_AND_TOOLS.DESCRIPTION,
          [RouteNamesExternal.MEMBER_FEEDBACK],
        ),

        link: createSearchLink(
          'performance_resources_orderby_date_desc',
          'Performance Resource > Templates and Tools',
        ),
      },
    },
  },
  [tabs.ARTICLES]: {
    tabName: 'Articles',
    link: createSearchLink('articles_orderby_date_desc', 'Article'),
    requests: {
      [requests.NEWS_LETTER]: {
        getInput: (isMobile: boolean) => ({
          index: 'articles_orderby_date_desc',
          pageSize: isMobile ? 1 : 3,
          filters:
            '(contentTypes.lvl1:"Article > Newsletter Article") AND (memberBenefit:true)',
        }),
        title: 'Newsletter Articles',
        description:
          'Stay on top of the latest news and trends in talent development curated specifically for our members.',
        link: createSearchLink(
          'articles_orderby_date_desc',
          'Article > Newsletter Article',
        ),
      },
      [requests.TD_MAGAZINE_ARTICLES]: {
        getInput: (isMobile: boolean) => ({
          index: 'articles_orderby_date_desc',
          pageSize: isMobile ? 1 : 3,
          filters:
            '(contentTypes.lvl1:"Article > TD Magazine Article") AND (memberBenefit:true)',
        }),
        title: 'TD Magazine Articles',
        description:
          'Articles from our monthly award-winning magazine that examines industry trends and topics.',
        link: createSearchLink(
          'articles_orderby_date_desc',
          'Article > TD Magazine Article',
        ),
      },
    },
  },
  [tabs.WEBINARS]: {
    tabName: 'Webinars',
    link: createSearchLink('webinars_orderby_date_desc', 'Webinar'),
    requests: {
      [requests.WEBINARS]: {
        getInput: () => ({
          index: 'webinars_orderby_date_desc',
          pageSize: 6,
          filters: 'memberBenefit:true',
        }),
        title: 'Webinars',
        description:
          'The full archive of webinar recordings available for members to quickly build skills and competencies on critical topics.',
        link: createSearchLink('webinars_orderby_date_desc', ''),
      },
    },
  },
}

export const callCustomerCodes = [
  'PROF_ENTERPRISE',
  'PROF_GROUP',
  'PROF_GROUP2',
  'PROF_GROUP3',
  'PROF_ENTERPRISE2',
  'PROF_ENTERPRISE3',
  'BASIC1',
  'BASIC2',
  'BASIC3',
  'PROF_INDIV',
  'PROF_INDIV2',
  'PROF_INDIV3',
  'PROF_INTL',
  'INDIV',
  'INDIV2',
  'INDIV3',
]

export const launchLMSCodes = [
  'PLUSENTERPRISE',
  'PLUSGROUP',
  'PLUSENTERPRISE3',
  'PLUSGROUP2',
  'PLSUGROUP3',
  'PLUSENTERPRISE2',
  'PLUSGROUP3',
  'PLUSENTERPRISERC',
  'BRONZE1',
  'BRONZE2',
  'BRONZE3',
  'SILVER1',
  'SILVER2',
  'SILVER3',
  'GOLD1',
  'GOLD2',
  'GOLD3',
  'PLUS',
  'PLUS2',
  'PLUS3',
  'PLUS20',
  'PLUS_INTL',
  'PLUS_INTL20',
  'CLAPLUS',
]
